import resources from './resouces';

export const config = {
  interpolation: { escapeValue: false }, // React already does escaping
  lng: 'en',
  resources,
};

export { resources };